import type { TFunction } from 'i18next';

/** Ledger transaction types a player can filter the account statement by. */
export const STATEMENT_TX_TYPES = [
  'Stake',
  'Payment',
  'Cash out',
  'Deposit',
  'Withdrawal',
  'Bet',
  'Win',
  'Bonus',
  'Casino games - Withdrawal',
  'Casino games - Deposit',
];

const KEYS: Record<string, string> = {
  stake: 'tx_stake',
  payment: 'tx_payment',
  'payment correction': 'tx_payment_correction',
  'cash out': 'cash_out_label',
  deposit: 'tx_deposit',
  withdrawal: 'tx_withdrawal',
  bet: 'tx_bet',
  win: 'tx_win',
  refund: 'tx_refund',
  bonus: 'tx_bonus',
  'casino games - withdrawal': 'tx_casino_withdrawal',
  'casino games - deposit': 'tx_casino_deposit',
};

/** A ledger transaction name in the player's language (unknown ones as is). */
export function txTypeLabel(t: TFunction, raw: string | null | undefined) {
  const key =
    KEYS[
      String(raw ?? '')
        .trim()
        .toLowerCase()
    ];
  return key ? t(key) : String(raw ?? '');
}
